import React, { Fragment } from 'react';
import styled from 'styled-components';
import { useDialog, P } from '@yuhu-inc/yuhui';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

import { DialogForConfirmation } from 'components/shared/DialogForConfirmation';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const StyledHeader = styled(P)`
  font-size: 24px;
  font-family: 'Circular-Black', sans-serif;
  text-align: center;
`;

const StyledP = styled(P)`
  font-size: 18px;
  text-align: center;
`;

export const DeleteRuleConfirmationDialog = ({ handleConfirmation, disabled }) => {
  const dialog = useDialog();

  if (disabled) return null;

  return (
    <Fragment>
      <IconButton
        style={{ float: 'right', padding: '0px', backgroundColor: '#fff' }}
        onClick={dialog.show}
      >
        <DeleteIcon size={24} style={{ padding: '0px' }} />
      </IconButton>
      <DialogForConfirmation
        handleConfirmation={handleConfirmation}
        noKey="landlordPortal.rules.deleteConfirmationNo"
        yesKey="landlordPortal.rules.deleteConfirmationYes"
        {...dialog}
      >
        <StyledContainer>
          <StyledHeader contentKey="landlordPortal.rules.deleteConfirmationHeader" />
          <StyledP contentKey="landlordPortal.rules.deleteConfirmationP" />
        </StyledContainer>
      </DialogForConfirmation>
    </Fragment>
  );
};
